// removed by extract-text-webpack-plugin
module.exports = {"container":"CrewList__container__2Dktc","image":"CrewList__image__mQIBD","name":"CrewList__name__1_bKu","role":"CrewList__role__24D6q","expand":"CrewList__expand__3TePd","border":"CrewList__border__3TU-A"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Leadership/CrewList/CrewList.scss
// module id = 483
// module chunks = 0